import React from 'react';
import './GlobalStyles.scss';
import { StyledEngineProvider } from '@mui/material/styles';
import { Experimental_CssVarsProvider as CssVarsProvider } from '@mui/material/styles';
import { GlobalTheme } from './GlobalTheme';
import 'react-toastify/ReactToastify.min.css';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import CssBaseline from '@mui/material/CssBaseline';
const queryClient = new QueryClient();
const GlobalConfiguration = ({ children }: any) => {
  return (
    <QueryClientProvider client={queryClient}>
      <CssVarsProvider theme={GlobalTheme}>
        <CssBaseline />
        <StyledEngineProvider injectFirst>{children}</StyledEngineProvider>
        <ToastContainer position={'top-center'} autoClose={3000} newestOnTop />
      </CssVarsProvider>
    </QueryClientProvider>
  );
};

export default GlobalConfiguration;
